<template>
    <div>
        <b-form-group v-if="canChangeMainPassword">
            <template v-slot:label>
                {{mainPasswordLabel}}
                <font-awesome-icon icon="spinner-third" spin v-if="password_loading"></font-awesome-icon>
            </template>
            <password-field v-model="mainPassword" :generator="true" ref="password"
                    @generate="doGenerate('mainPassword')"></password-field>
            <password-strength-indicator :value="mainPassword" :minLength="$store.state.settings.minpasswordlength"
                    @score="setMainScore" :extra-error="password_result"></password-strength-indicator>
        </b-form-group>

        <b-form-group v-if="$store.state.settings.separatewebmailpassword">
            <template v-slot:label>
                {{$t('webmailPasswordLabel')}}
                <font-awesome-icon icon="spinner-third" spin v-if="password_loading"></font-awesome-icon>
            </template>
            <password-field v-model="webPassword" :generator="true" ref="webpassword"
                    @generate="doGenerate('webPassword')"></password-field>
            <password-strength-indicator :value="webPassword" :minLength="$store.state.settings.minpasswordlength"
                    @score="setWebScore" :extra-error="webpassword_result"></password-strength-indicator>
        </b-form-group>

        <b-button :disabled="buttonDisabled" variant="primary" @click="doSave">{{$t('savePasswords')}}</b-button>

        <two-factor-authentication></two-factor-authentication>
    </div>
</template>

<script>
import PasswordField from '@/components/passwordField';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import omgopass from 'omgopass';
import TwoFactorAuthentication from '@/components/twoFactorAuthentication';

const PasswordStrengthIndicator = () =>
  import(/* webpackChunkName: "passwordStrength" */'@/components/passwordStrengthIndicator');

export default {
  name: 'passwords',
  components: { PasswordStrengthIndicator, PasswordField, FontAwesomeIcon, TwoFactorAuthentication },
  i18nOptions: { keyPrefix: 'settings.passwords' },
  data: function() {
    return {
      mainPassword: '',
      mainScore: {},
      password_loading: false,
      password_result: '',
      webPassword: '',
      webScore: {},
      webpassword_loading: false,
      webpassword_result: ''
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    setMainScore(score) {
      this.mainScore = score;
    },
    setWebScore(score) {
      this.webScore = score;
    },
    doGenerate(passwordType) {
      console.log('do generate');
      this.reallyDoGenerate(passwordType);
    },
    async reallyDoGenerate(passwordType) {
      console.log('really do generate');
      let newPassword = '';
      try {
        const d = await this.$RPC(`settings/password`, 'generate', { length: 10 });
        console.log('generate', d);
        newPassword = d.password;
      } catch (err) {
        console.log('error', err);
      }
      if (!newPassword) {
        let minLength = this.$store.state.settings.minpasswordlength;
        if (minLength < 10) {
          minLength = 10;
        }
        let syllables = 2;
        if (minLength > 13) {
          syllables = Math.floor(minLength / 6.5) + 1;
        }
        do {
          const titlecased = Math.random() < 0.5;
          const separators = "!\"$%^&*()_-+=}]{[@':;>.<,?/";
          let separator = '';
          if (Math.random() < 0.5) {
            separator = separators.substr(Math.floor(Math.random() * separators.length), 1);
          }
          newPassword = omgopass({ syllablesCount: syllables,
            titlecased,
            separators: separator,
            minSyllableLength: 5,
            maxSyllableLength: 6 });
        } while (newPassword.length < minLength);
      }

      this[passwordType] = newPassword;
    },
    doSave() {
      this.savePassword('password', this.mainPassword);
      this.savePassword('webpassword', this.webPassword);
    },
    savePassword(type, password) {
      if (password === '') {
        return;
      }
      this[`${type}_loading`] = true;

      axios.patch(`/rest/user/settings/${type}`, { password })
        .then(d => {
          this[`${type}_result`] = '';
          switch (type) {
            case 'password':
              this.mainPassword = '';
              break;
            case 'webpassword':
              this.webPassword = '';
              break;
          }
          this.$refs[type].hidePassword();
          this[type] = '';
        })
        .catch(e => {
          console.dir(e);
          this[`${type}_result`] = this.$t(`saveError.${e.response.data.error}`);
        })
        .finally(() => {
          this[`${type}_loading`] = false;
        });
    }
  },
  computed: {
    canChangeMainPassword() {
      return (this.$store.state.settings.canchangenonwebpassword) ||
        (!this.$store.state.settings.separatewebmailpassword);
    },
    mainPasswordLabel() {
      if (this.$store.state.settings.separatewebmailpassword) {
        if (this.$store.state.settings.enterprise) {
          return this.$t('mainPasswordLabelEnterprise');
        } else {
          return this.$t('mainPasswordLabelBasic');
        }
      } else {
        return this.$t('passwordLabel');
      }
    },
    loading() {
      return ((this.password_loading) || (this.webpassword_loading));
    },
    buttonDisabled() {
      if (this.loading) {
        return true;
      }
      if ((this.mainPassword.length === 0) && (this.webPassword.length === 0)) {
        return true;
      }
      const minComplexity = this.$store.state.settings.minpasswordcomplexity;
      if (this.mainPassword.length > 0) {
        if (this.mainPassword.length < this.$store.state.settings.minpasswordlength) {
          return true;
        }
        if (this.mainScore.score < minComplexity) {
          return true;
        }
      }
      if (this.webPassword.length > 0) {
        if (this.webPassword.length < this.$store.state.settings.minpasswordlength) {
          return true;
        }
        if (this.webScore.score < minComplexity) {
          return true;
        }
      }
      return false;
    }
  }
};
</script>

<style scoped lang="scss">

</style>
